import type { FaireProductEntity } from "../../entity_types/product";

export const p_9r26u7ep2w: FaireProductEntity = {
  token: "p_9r26u7ep2w",
  type: "product",
  name: "NEW! Bella Cat Pet Bowl",
  brandToken: "b_65zgi875pr",
  brandName: "Laurel Burch Studios",
  imageUrl:
    "https://cdn.faire.com/fastly/cdfe0772abf9837f4362dd8738273ff0f3a21717b1c7518440fcd57dbaad5e43.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ca3c6574b34fc639850f3007eb903cd237b9b329fb83aed1d7d6f9e901ebb907.jpeg",
    "https://cdn.faire.com/fastly/dd53bbd9081b62e4dcb94bafdb6930230f017a214b9a0748c63b150385157528.png",
  ],
  priceDollars: 10.35,
  description:
    "Laurel loved her animals and we think it's about time kitties got something bright and beautiful, too. Be the first to spoil your fur baby with this sturdy, well-crafted bowl adorned with Bella Cat prowling amidst flowers and bright green grass. It holds one cup of food and adds paw-sonality and color to meals!  Removable stainless steel bowl  Colorful melamine base, anti-slip rubber bottom  Half-moon notch in base makes it easy to pick up  Dishwasher safe, top rack; do not microwave Item Number: PB003Capacity: 1 cup/8 oz. capacity Dimensions: 4.5'' bowl diam.; 5.5'' base diam.; 2''H x1.25''DMaterial: Melamine, rubber; stainless steel",
  tags: [],
  msrpDollars: 23,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:01:35.227Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
